// deps
import React, { memo } from "react";

// internal deps
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { StarIcon } from "./StarIcon";
// styles
import {
    TextContainer,
    RedeemableStyledText,
    SavingContainer,
    SavingsBackgroundWrapper,
    ImageContainer,
    StyledSavingsText,
    SavingsText,
    AnimationWrapper,
    RewardRedeemedContent,
    NonRewardContent,
} from "./styles";

//constants
import { SAVING_IMAGE_DIMENSTION } from "@dineout-cart-ui/constants/index";
import { IColors, ITypographyV2 } from "@swiggy-private/dls-web-common/dist/components/types.internal";

interface SavingsCalloutProps {
    dineoutMastHeadTextWidget?: { text?: string; color?: string };
    savingsText?: string;
    savingsImage: string;
    popupSavingsBackgroundImage: string;
    showSavingsAnimation: boolean;
    rewardText?: string;
    savingsTextColor?: string;
    savingsTextVariant?: string;
    isRewardRedeemed: boolean;
    shouldAnimate: boolean;
}
const SavingsCallout: React.FC<SavingsCalloutProps> = (props: SavingsCalloutProps) => {
    const {
        dineoutMastHeadTextWidget,
        savingsText,
        savingsImage,
        popupSavingsBackgroundImage,
        showSavingsAnimation,
        rewardText,
        isRewardRedeemed,
        shouldAnimate,
        savingsTextVariant,
        savingsTextColor,
    } = props;
    return (
        <>
            {dineoutMastHeadTextWidget?.text && (
                <TextContainer>
                    <RedeemableStyledText variant="V2.subheading1.neutral.medium" isRewardRedeemed={isRewardRedeemed}>
                        <StarIcon />
                        <div dangerouslySetInnerHTML={{ __html: dineoutMastHeadTextWidget.text }} />
                        <StarIcon />
                    </RedeemableStyledText>
                </TextContainer>
            )}
            {savingsText && (
                <SavingContainer toAnimate={showSavingsAnimation}>
                    <SavingsBackgroundWrapper
                        isRewardRedemed={isRewardRedeemed}
                        backgroundImage={popupSavingsBackgroundImage}
                    >
                        <ImageContainer>
                            <Image
                                src={savingsImage}
                                width={SAVING_IMAGE_DIMENSTION.width}
                                height={SAVING_IMAGE_DIMENSTION.height}
                            />
                        </ImageContainer>
                        <StyledSavingsText
                            variant={isRewardRedeemed ? "V2.body1.neutral.bold" : "V2.subheading1.neutral.medium"}
                            color={isRewardRedeemed ? "positive_Sub" : "positive"}
                            maxLines={1}
                        >
                            <AnimationWrapper>
                                <RewardRedeemedContent
                                    isRewardRedeemed={isRewardRedeemed}
                                    shouldAnimate={shouldAnimate}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: savingsText }} />
                                    <SavingsText
                                        variant={
                                            (savingsTextVariant as keyof ITypographyV2) || "V2.body3.neutral.medium"
                                        }
                                        color={(savingsTextColor as keyof IColors) || "text_inverse_High_Emphasis"}
                                    >
                                        {rewardText}
                                    </SavingsText>
                                </RewardRedeemedContent>
                                <NonRewardContent isRewardRedeemed={isRewardRedeemed} shouldAnimate={shouldAnimate}>
                                    <div dangerouslySetInnerHTML={{ __html: savingsText }} />
                                </NonRewardContent>
                            </AnimationWrapper>
                        </StyledSavingsText>
                    </SavingsBackgroundWrapper>
                </SavingContainer>
            )}
        </>
    );
};

export default memo(SavingsCallout);
